import { Navigate } from "react-router-dom";
import { useOssAuth } from "../../context/OssAuthContext";
import OssSectionPageHeader from "../../components/oss/OssSectionPageHeader";
import StampeMensiliTab from "../../components/documenti/StampeMensiliTab";

export default function OssStampeMensili() {
  const { token, activeOss } = useOssAuth();
  if (!activeOss?.responsabile) {
    return <Navigate to="/oss" replace />;
  }

  return (
    <div className="max-w-6xl mx-auto space-y-1">
      <StampeMensiliTab
        token={token}
        apiBase="/api/oss/me/stampe-mensili"
        showIntro={false}
        renderWithToolbar={(toolbar) => (
          <OssSectionPageHeader
            sectionKey="stampeMensili"
            title="Stampe mensili"
            subtitle="Alvo, docce, HACCP, fogli firma e registri"
            toolbar={toolbar}
          />
        )}
      />
    </div>
  );
}
